import Swiper from 'swiper';

function initCarousel() {
    // eslint-disable-next-line no-new
    new Swiper('.js-news-carousel', {
        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
            992: {
                slidesPerView: 3,
            }
        }
    });
}

initCarousel();
